// Extracted from web/App.tsx; behavior and declaration bodies preserved.
export function Brand({
  large = false,
  name = "DataGlow",
}: {
  large?: boolean;
  name?: string;
}) {
  return (
    <div className={`brand ${large ? "large" : ""}`}>
      <svg viewBox="0 0 34 34" role="img" aria-label="DataGlow logo">
        <path
          d="M6 10 17 4l11 6v14l-11 6L6 24Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.4"
        />
        <path
          d="m6 10 11 6 11-6M17 16v14M6 24l11-8 11 8"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.4"
        />
        <circle cx="17" cy="16" r="3.4" fill="currentColor" />
        <circle cx="6" cy="10" r="2.2" fill="currentColor" />
        <circle cx="28" cy="10" r="2.2" fill="currentColor" />
      </svg>
      <span>
        {name === "DataGlow" ? (
          <>
            Data<span>Glow</span>
          </>
        ) : (
          name
        )}
      </span>
      {large && <small>ER DESIGNER</small>}
    </div>
  );
}
